import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-5 py-10 space-y-10" }
const _hoisted_2 = { class: "flex flex-col space-y-6 items-center" }
const _hoisted_3 = { class: "flex w-full flex-col space-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "w-full text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "w-full text-center"
}
const _hoisted_6 = {
  key: 2,
  class: "w-full text-center"
}
const _hoisted_7 = { class: "flex flex-col space-y-2 w-full items-center" }

import {onMounted, ref} from 'vue';
import {AccountType} from "@/definitions/AccountType";
import InputCheckbox from "@/components/InputCheckbox.vue";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {Preferences} from "@capacitor/preferences";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {modalController} from "@ionic/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountTypeSheet',
  setup(__props) {


const loading = ref(true)
const accountType = ref([])

const accountTypes = [
  {
    text: 'Individual',
    value: AccountType.Individual,
  },
  {
    text: 'Joint',
    value: AccountType.Joint,
  },
  {
    text: 'Club',
    value: AccountType.Club,
  },
  {
    text: 'Host',
    value: AccountType.Host,
  }
]

onMounted(async () => {
  loading.value = false
})

const saveAccountType = async () => {
  const key = PreferenceKey.OnboardingAccountType
  const value = accountType.value[0]
  await Preferences.set({
    key,
    value
  })
  await modalController.dismiss()
  await ApiService.User().setPreference(key, value)
  await Observable.emit(ObservableEvent.UserChanged)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"flex text-brand-lime\"><svg class=\"fill-current w-10 h-10\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z\"></path></svg></div><div class=\"flex flex-col w-full items-center space-y-1 px-2\"><div class=\"flex text-white text-2xl font-medium text-center\">Linked accounts are here!</div><div class=\"text-brand-light-gray text-lg text-center\">Choose the account type that best describes how you&#39;ll be using Pineapple. </div></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(accountTypes, (a, aIndex) => {
          return _createVNode(InputCheckbox, {
            key: aIndex,
            name: "accountType",
            modelValue: accountType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountType).value = $event)),
            "return-single-value": true,
            option: a
          }, null, 8, ["modelValue", "option"])
        }), 64))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{
            'opacity-0' : !accountType.value.length
          }, "flex w-full px-5 text-brand-light-gray text-center items-center"])
      }, [
        (accountType.value[0] === _unref(AccountType).Individual)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "For singles or couples who would like their own profile. Profiles can be linked together so you are presented as a couple to the community. "))
          : _createCommentVNode("", true),
        (accountType.value[0] === _unref(AccountType).Joint)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Perfect for couples who'd like to share a single account and profile, your profile is based on your collective desires and interests. "))
          : _createCommentVNode("", true),
        (accountType.value[0] === _unref(AccountType).Club)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "For clubs and businesses."))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: saveAccountType,
          class: _normalizeClass([{
                  'bg-opacity-40' : !accountType.value.length
                }, "flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
            _createElementVNode("div", { class: "my-auto pt-0.5" }, [
              _createElementVNode("div", null, "Done")
            ])
          ], -1)
        ]))], 2)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-brand-light-gray text-xs text-center px-10" }, "You can change this at any time from your profile buy may be required to re verify your profile.", -1))
    ])
  ]))
}
}

})